/**
 * Send event to google analytics
 *
 * @param {String} category GA Category
 * @param {String} action GA Action
 * @param {String} label GA Label
 *
 */
export default function sendGA(category, action, label) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'SEND_EVENT_GA',
    actionEvent: action,
    categoryEvent: category,
    labelEvent: label,
  });
}
